<template>
    <div class="modalOverlay" @click="close">
        <div class="modal fade show" tabindex="-1" style="display: block; z-index: 10; cursor: default;">
            <div class="modal-dialog modal-dialog-centered modal-m modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="titleContainer">
                            <p class="modal-title titleText">{{ modal.titulo }}</p>
                        </div>
                        <button type="button" class="btn-close" @click="close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="modal.loading" class="text-center py-4">
                            <p>Cargando historial...</p>
                            <div style="display: flex;flex-direction: row;justify-content: center;">
                                <span class="loader"></span>
                            </div>
                        </div>

                        <div v-else-if="modal.data">
                            <TableHistorialComponent :data="modal.data" />
                        </div>

                        <div v-else class="text-center py-4">
                            <p>No se encontraron registros históricos</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import TableHistorialComponent from './table/TableHistorialComponent.vue';

defineProps({
    modal: Object
});

const emit = defineEmits(['close']);

const close = () => {
    emit('close');
}
</script>

<style>
.modalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 550;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid var(--verdePrincipal);
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>